"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _common = require("@insided/shared/utils/common");

var _axios = _interopRequireDefault(require("axios"));

var _IntegrationSetup = _interopRequireDefault(require("./IntegrationSetup"));

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _theloops = require("./components/theloops");

var _PanelItems = require("./components/PanelItems");

var _UninstallModal = _interopRequireDefault(require("./components/UninstallModal"));

var _constants = require("@insided/shared/constants");

var _theLoops = require("./components/theloops/theLoops.constants");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var TheLoopsIntegration = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(TheLoopsIntegration, _Component);

  var _super = _createSuper(TheLoopsIntegration);

  function TheLoopsIntegration() {
    var _this;

    (0, _classCallCheck2.default)(this, TheLoopsIntegration);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      isInstalled: false,
      isEnabled: _common.common.isModuleActive('theLoopsAIWidget'),
      autopilotNavbar: _common.common.isModuleActive('autopilotNavbar'),
      selectedWidget: '',
      loopsTenantId: '',
      sharedSecret: '',
      domain: '',
      storedState: {
        sharedSecret: '',
        domain: ''
      },
      activeTab: 0,
      showUnsavedChangesModal: false,
      showUninstallModal: false,
      isLoadingOnboard: true,
      subdomainErrorMessage: undefined,
      sharedSecretErrorMessage: undefined
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "syncPropsToState", function () {
      var _this$props$sharedSec, _this$props$domain, _this$props$isInstall, _this$props$sharedSec2, _this$props$domain2;

      _this.setState({
        sharedSecret: (_this$props$sharedSec = _this.props.sharedSecret) !== null && _this$props$sharedSec !== void 0 ? _this$props$sharedSec : '',
        domain: (_this$props$domain = _this.props.domain) !== null && _this$props$domain !== void 0 ? _this$props$domain : '',
        isInstalled: (_this$props$isInstall = _this.props.isInstalled) !== null && _this$props$isInstall !== void 0 ? _this$props$isInstall : false,
        storedState: {
          sharedSecret: (_this$props$sharedSec2 = _this.props.sharedSecret) !== null && _this$props$sharedSec2 !== void 0 ? _this$props$sharedSec2 : '',
          domain: (_this$props$domain2 = _this.props.domain) !== null && _this$props$domain2 !== void 0 ? _this$props$domain2 : ''
        }
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onInstall", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      var _subdomainErrorMessag;

      var _this$state, sharedSecret, domain, subdomainErrorMessage, sharedSecretErrorMessage, response, _response$data$messag, _error$response$data$, _error$response, _error$response$data, errorMessage;

      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.dismissMessage();

              _this$state = _this.state, sharedSecret = _this$state.sharedSecret, domain = _this$state.domain;

              if (!domain.trim()) {
                subdomainErrorMessage = _theLoops.THELOOPS_MESSAGES.DOMAIN_REQUIRED;
              }

              if (!sharedSecret.trim()) {
                sharedSecretErrorMessage = _theLoops.THELOOPS_MESSAGES.API_KEY_REQUIRED;
              }

              if (!((_subdomainErrorMessag = subdomainErrorMessage) !== null && _subdomainErrorMessag !== void 0 ? _subdomainErrorMessag : sharedSecretErrorMessage)) {
                _context.next = 7;
                break;
              }

              _this.setState({
                subdomainErrorMessage: subdomainErrorMessage,
                sharedSecretErrorMessage: sharedSecretErrorMessage,
                messageType: 'error'
              });

              return _context.abrupt("return");

            case 7:
              _context.prev = 7;

              _this.setState({
                isSavingCredentials: true
              });

              _context.next = 11;
              return TheLoopsIntegration.install(sharedSecret, domain);

            case 11:
              response = _context.sent;

              if (response.data.success) {
                _this.setState(function (prevState) {
                  var updatedStoredState = _objectSpread({}, prevState.storedState);

                  updatedStoredState.sharedSecret = '********************';
                  updatedStoredState.domain = domain.trim();
                  return {
                    isInstalled: true,
                    sharedSecret: '********************',
                    storedState: updatedStoredState,
                    subdomainErrorMessage: undefined,
                    sharedSecretErrorMessage: undefined,
                    messageType: 'success',
                    message: _theLoops.THELOOPS_MESSAGES.INSTALL_SUCCESS
                  };
                });
              } else {
                _this.setState({
                  subdomainErrorMessage: undefined,
                  sharedSecretErrorMessage: undefined,
                  messageType: 'error',
                  message: (_response$data$messag = response.data.message) !== null && _response$data$messag !== void 0 ? _response$data$messag : _theLoops.THELOOPS_MESSAGES.INSTALL_ERROR
                });
              }

              _context.next = 19;
              break;

            case 15:
              _context.prev = 15;
              _context.t0 = _context["catch"](7);
              errorMessage = (_error$response$data$ = (_error$response = _context.t0.response) === null || _error$response === void 0 ? void 0 : (_error$response$data = _error$response.data) === null || _error$response$data === void 0 ? void 0 : _error$response$data.message) !== null && _error$response$data$ !== void 0 ? _error$response$data$ : _theLoops.THELOOPS_MESSAGES.INSTALL_ERROR;

              _this.setState({
                subdomainErrorMessage: undefined,
                sharedSecretErrorMessage: undefined,
                messageType: 'error',
                message: errorMessage
              });

            case 19:
              _context.prev = 19;

              _this.setState({
                isSavingCredentials: false
              });

              return _context.finish(19);

            case 22:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[7, 15, 19, 22]]);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onUninstall", /*#__PURE__*/function () {
      var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(event) {
        var response, errorMessage;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (event) {
                  event.preventDefault();
                  event.stopPropagation();
                }

                _context2.prev = 1;
                _context2.next = 4;
                return TheLoopsIntegration.uninstall();

              case 4:
                response = _context2.sent;

                if (!response.data.success) {
                  _context2.next = 9;
                  break;
                }

                _this.setState({
                  isInstalled: false,
                  isEnabled: false,
                  autopilotNavbar: false,
                  sharedSecret: '',
                  domain: '',
                  storedState: {
                    sharedSecret: '',
                    domain: ''
                  },
                  showUninstallModal: false,
                  messageType: 'success',
                  message: _theLoops.THELOOPS_MESSAGES.UNINSTALL_SUCCESS
                });

                _context2.next = 10;
                break;

              case 9:
                throw new Error(response.data.message || _theLoops.THELOOPS_MESSAGES.UNINSTALL_ERROR);

              case 10:
                _context2.next = 16;
                break;

              case 12:
                _context2.prev = 12;
                _context2.t0 = _context2["catch"](1);
                errorMessage = TheLoopsIntegration.getErrorMessage(_context2.t0, _theLoops.THELOOPS_MESSAGES.UNINSTALL_ERROR, 'Uninstallation failed');

                _this.setState({
                  messageType: 'error',
                  message: errorMessage,
                  showUninstallModal: false
                });

              case 16:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[1, 12]]);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "resetCredentials", function () {
      var storedState = _this.state.storedState;

      _this.setState({
        sharedSecret: storedState.sharedSecret,
        domain: storedState.domain
      });

      _this.dismissMessage();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setActiveTab", function (selectedTab) {
      if (_this.checkPanelHasUnsavedChanges()) {
        _this.setState({
          showUnsavedChangesModal: true
        });

        return;
      }

      _this.setState({
        activeTab: selectedTab
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onResetInstallationTab", function (activeTab) {
      _this.resetCredentials();

      _this.dismissMessage();

      _this.setState({
        activeTab: activeTab,
        showUnsavedChangesModal: false
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onResetIntegrationTab", function (activeTab) {
      _this.resetCredentials();

      _this.setState({
        activeTab: activeTab,
        showUnsavedChangesModal: false
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "displayUnsavedChangedModal", function () {
      _this.setState({
        showUnsavedChangesModal: true
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onClickUninstallButton", function () {
      _this.setState({
        showUninstallModal: true
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "closeUninstallModal", function () {
      _this.setState({
        showUninstallModal: false
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "closeModal", function () {
      _this.setState({
        showUnsavedChangesModal: false
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "dismissMessage", function () {
      _this.setState({
        message: undefined,
        messageType: undefined,
        subdomainErrorMessage: undefined,
        sharedSecretErrorMessage: undefined
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onSharedChange", function (value) {
      _this.setState({
        sharedSecret: value
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onDomainChange", function (value) {
      _this.setState({
        domain: value
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onToggleIntegration", function () {
      var isEnabled = _this.state.isEnabled;

      _this.setState({
        isEnabled: !isEnabled
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onSaveIntegrationSettings", /*#__PURE__*/function () {
      var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(showAutopilotNavbar, selectedWidget) {
        var isEnabled, validationError, _results$widget, payload, response, _response$data, success, message, results, _results$widget$data$, _results$widget$data, _results$toggles$auto, _results$toggles$ccWi, errorMessage;

        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                isEnabled = _this.state.isEnabled;
                validationError = TheLoopsIntegration.validateIntegrationSettings(selectedWidget, isEnabled);

                if (!validationError) {
                  _context3.next = 5;
                  break;
                }

                _this.setState({
                  messageType: 'error',
                  message: validationError
                });

                return _context3.abrupt("return");

              case 5:
                _context3.prev = 5;
                payload = {
                  ccWidgetEnabled: isEnabled,
                  autopilotNavbarEnabled: showAutopilotNavbar,
                  selectedWidget: isEnabled ? selectedWidget : ''
                };
                _context3.next = 9;
                return _axios.default.post(_theLoops.THELOOPS_API_ENDPOINTS.ENABLE_WIDGET, payload);

              case 9:
                response = _context3.sent;
                _response$data = response.data, success = _response$data.success, message = _response$data.message, results = _response$data.results;

                if (success) {
                  _context3.next = 13;
                  break;
                }

                throw new Error(message !== null && message !== void 0 ? message : 'Settings save failed');

              case 13:
                if (results !== null && results !== void 0 && (_results$widget = results.widget) !== null && _results$widget !== void 0 && _results$widget.result) {
                  _this.setState({
                    messageType: 'success',
                    message: (_results$widget$data$ = (_results$widget$data = results.widget.data) === null || _results$widget$data === void 0 ? void 0 : _results$widget$data.message) !== null && _results$widget$data$ !== void 0 ? _results$widget$data$ : 'Widget enabled successfully'
                  });
                }

                if (results !== null && results !== void 0 && results.toggles) {
                  if ((_results$toggles$auto = results.toggles.autopilotNavbar) !== null && _results$toggles$auto !== void 0 && _results$toggles$auto.success) {
                    _this.setState({
                      autopilotNavbar: results.toggles.autopilotNavbar.value
                    });
                  }

                  if ((_results$toggles$ccWi = results.toggles.ccWidget) !== null && _results$toggles$ccWi !== void 0 && _results$toggles$ccWi.success) {
                    _this.setState({
                      isEnabled: results.toggles.ccWidget.value
                    });
                  }
                }

                _this.setState({
                  messageType: 'success',
                  message: message !== null && message !== void 0 ? message : 'Settings saved successfully'
                });

                _context3.next = 22;
                break;

              case 18:
                _context3.prev = 18;
                _context3.t0 = _context3["catch"](5);
                errorMessage = TheLoopsIntegration.getErrorMessage(_context3.t0, _theLoops.THELOOPS_MESSAGES.SETTINGS_SAVE_ERROR, 'Failed to save settings');

                _this.setState({
                  messageType: 'error',
                  message: errorMessage
                });

              case 22:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[5, 18]]);
      }));

      return function (_x2, _x3) {
        return _ref3.apply(this, arguments);
      };
    }());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "fetchOnboardData", function () {
      _axios.default.get(_theLoops.THELOOPS_API_ENDPOINTS.ONBOARD_COMMUNITY_DETAILS).then(function (response) {
        if (response.data.result) {
          var _response$data$data = response.data.data,
              loopsDomainUrl = _response$data$data.loops_domain_url,
              status = _response$data$data.status,
              isDeleted = _response$data$data.is_deleted,
              widgetId = _response$data$data.widget_id,
              loopsTenantId = _response$data$data.loops_tenant_id;

          _this.setState({
            sharedSecret: '********************',
            domain: loopsDomainUrl !== null && loopsDomainUrl !== void 0 ? loopsDomainUrl : '',
            isInstalled: status === 'Active' && !isDeleted,
            isEnabled: _common.common.isModuleActive('theLoopsAIWidget'),
            autopilotNavbar: _common.common.isModuleActive('autopilotNavbar'),
            selectedWidget: widgetId !== null && widgetId !== void 0 ? widgetId : '',
            loopsTenantId: loopsTenantId !== null && loopsTenantId !== void 0 ? loopsTenantId : '',
            storedState: {
              sharedSecret: '********************',
              domain: loopsDomainUrl !== null && loopsDomainUrl !== void 0 ? loopsDomainUrl : ''
            },
            isLoadingOnboard: false
          });
        } else {
          _this.setState({
            isLoadingOnboard: false
          });
        }
      }).catch(function (error) {
        console.error('Failed to fetch onboard data:', error);

        _this.setState({
          isLoadingOnboard: false
        });
      });
    });
    return _this;
  }

  (0, _createClass2.default)(TheLoopsIntegration, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.fetchOnboardData();
      this.syncPropsToState();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.sharedSecret !== this.props.sharedSecret || prevProps.domain !== this.props.domain) {
        this.syncPropsToState();
      }
    }
  }, {
    key: "checkPanelHasUnsavedChanges",
    value: function checkPanelHasUnsavedChanges() {
      var _this$state2 = this.state,
          sharedSecret = _this$state2.sharedSecret,
          domain = _this$state2.domain,
          storedState = _this$state2.storedState;
      return sharedSecret !== storedState.sharedSecret || domain !== storedState.domain;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      if (this.state.isLoadingOnboard) {
        return (0, _preact.h)("div", null);
      }

      var _this$state3 = this.state,
          isInstalled = _this$state3.isInstalled,
          isEnabled = _this$state3.isEnabled,
          activeTab = _this$state3.activeTab,
          messageType = _this$state3.messageType,
          message = _this$state3.message,
          subdomainErrorMessage = _this$state3.subdomainErrorMessage,
          sharedSecretErrorMessage = _this$state3.sharedSecretErrorMessage,
          showUnsavedChangesModal = _this$state3.showUnsavedChangesModal,
          showUninstallModal = _this$state3.showUninstallModal,
          isSavingCredentials = _this$state3.isSavingCredentials,
          sharedSecret = _this$state3.sharedSecret,
          domain = _this$state3.domain;
      var panelHasUnsavedChanges = this.checkPanelHasUnsavedChanges();
      var enabledIntegrationCount = isInstalled ? 1 : 0;
      var installButton = null;

      if (!this.state.isLoadingOnboard) {
        installButton = isInstalled ? (0, _preact.h)(_PanelItems.InstallAndUninstallButtons, {
          onClickUninstallButton: function onClickUninstallButton() {
            return _this2.onClickUninstallButton();
          }
        }) : (0, _preact.h)(_Button.default, {
          size: "medium",
          variant: "brand",
          title: "Install now",
          className: "installation__button_cta",
          onClick: function onClick() {
            return _this2.setActiveTab(1);
          }
        });
      }

      var description = (0, _preact.h)("div", null, "TheLoops is an AI-powered support operations platform designed to help you scale customer service through intelligence and automation.", (0, _preact.h)("div", {
        className: "description-details"
      }, "With the TheLoops integration in Gainsight ", _constants.PLATFORM_BRAND_NAME, ", you can automatically answer community questions using an AI Answer Agent that references trusted content from your community. It enhances self-service by surfacing relevant articles and discussions in real-time through conversational AI. Additionally, it helps reduce repetitive support inquiries by deflecting common questions with AI-driven, context-aware responses."));
      var currentMessageType = message ? messageType : undefined;
      var commonModalProps = {
        showUnsavedChangesModal: showUnsavedChangesModal,
        closeModal: function closeModal() {
          return _this2.closeModal();
        },
        displayUnsavedChangedModal: function displayUnsavedChangedModal() {
          return _this2.displayUnsavedChangedModal();
        }
      };
      return (0, _preact.h)(_IntegrationSetup.default, {
        headerTitle: "TheLoops",
        appLogoName: "theloops-l",
        appContainerBackgroundColor: "#6825BD",
        dismissMessage: this.dismissMessage,
        messageType: currentMessageType,
        message: message,
        installButton: installButton,
        description: description,
        tabTitles: ['Integration', 'Installation'],
        activeTab: activeTab,
        onClickTab: function onClickTab(selectedTab) {
          return _this2.setActiveTab(selectedTab);
        },
        tabContents: [(0, _preact.h)(_theloops.IntegrationTab, (0, _extends2.default)({
          key: "integrationTab"
        }, commonModalProps, {
          resetChanges: function resetChanges() {
            return _this2.onResetIntegrationTab(1);
          },
          isInstalled: isInstalled,
          isEnabled: isEnabled,
          autopilotNavbar: this.state.autopilotNavbar,
          selectedWidget: this.state.selectedWidget,
          loopsTenantId: this.state.loopsTenantId,
          onToggleIntegration: this.onToggleIntegration,
          onCompleteInstallation: function onCompleteInstallation() {
            return _this2.setActiveTab(1);
          },
          onSaveIntegrationSettings: this.onSaveIntegrationSettings
        })), (0, _preact.h)(_theloops.InstallationTab, (0, _extends2.default)({
          key: "installationTab"
        }, commonModalProps, {
          resetChanges: function resetChanges() {
            return _this2.onResetInstallationTab(0);
          },
          sharedSecret: sharedSecret,
          domain: domain,
          isInstalled: isInstalled,
          onSave: /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4() {
            return _regenerator.default.wrap(function _callee4$(_context4) {
              while (1) {
                switch (_context4.prev = _context4.next) {
                  case 0:
                    _context4.next = 2;
                    return _this2.onInstall();

                  case 2:
                    return _context4.abrupt("return", _context4.sent);

                  case 3:
                  case "end":
                    return _context4.stop();
                }
              }
            }, _callee4);
          })),
          onCancel: function onCancel() {
            return _this2.resetCredentials();
          },
          onSharedChangeCallback: this.onSharedChange,
          onDomainChangeCallback: this.onDomainChange,
          onClickCallback: function onClickCallback() {
            if (_this2.state.subdomainErrorMessage || _this2.state.sharedSecretErrorMessage) {
              _this2.setState({
                subdomainErrorMessage: undefined,
                sharedSecretErrorMessage: undefined
              });
            }
          },
          onClickManage: function onClickManage() {
            return _this2.setActiveTab(0);
          },
          onClickUninstall: function onClickUninstall() {
            return _this2.onClickUninstallButton();
          },
          subdomainErrorMessage: subdomainErrorMessage,
          sharedSecretErrorMessage: sharedSecretErrorMessage,
          hasUnsavedChanges: panelHasUnsavedChanges,
          isSavingCredentials: isSavingCredentials
        }))],
        uninstallModal: (0, _preact.h)(_UninstallModal.default, {
          headerTitle: "TheLoops",
          onUninstall: /*#__PURE__*/function () {
            var _ref5 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5(event) {
              return _regenerator.default.wrap(function _callee5$(_context5) {
                while (1) {
                  switch (_context5.prev = _context5.next) {
                    case 0:
                      _context5.next = 2;
                      return _this2.onUninstall(event);

                    case 2:
                      return _context5.abrupt("return", _context5.sent);

                    case 3:
                    case "end":
                      return _context5.stop();
                  }
                }
              }, _callee5);
            }));

            return function (_x4) {
              return _ref5.apply(this, arguments);
            };
          }(),
          showUninstallModal: showUninstallModal,
          closeUninstallModal: function closeUninstallModal() {
            return _this2.closeUninstallModal();
          },
          enabledIntegrationCount: enabledIntegrationCount
        })
      });
    }
  }], [{
    key: "validateInstallInputs",
    value: function validateInstallInputs(sharedSecret, domain) {
      if (!sharedSecret.trim()) {
        return _theLoops.THELOOPS_MESSAGES.API_KEY_REQUIRED;
      }

      if (!domain.trim()) {
        return _theLoops.THELOOPS_MESSAGES.DOMAIN_REQUIRED;
      }

      return null;
    }
  }, {
    key: "install",
    value: function () {
      var _install = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee6(sharedSecret, domain) {
        return _regenerator.default.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return _axios.default.post(_theLoops.THELOOPS_API_ENDPOINTS.INSTALL, {
                  sharedSecret: sharedSecret.trim(),
                  domain: domain.trim()
                });

              case 2:
                return _context6.abrupt("return", _context6.sent);

              case 3:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      function install(_x5, _x6) {
        return _install.apply(this, arguments);
      }

      return install;
    }()
  }, {
    key: "uninstall",
    value: function () {
      var _uninstall = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee7() {
        return _regenerator.default.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return _axios.default.delete(_theLoops.THELOOPS_API_ENDPOINTS.UNINSTALL);

              case 2:
                return _context7.abrupt("return", _context7.sent);

              case 3:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));

      function uninstall() {
        return _uninstall.apply(this, arguments);
      }

      return uninstall;
    }()
  }, {
    key: "validateIntegrationSettings",
    value: function validateIntegrationSettings(selectedWidget, isEnabled) {
      if (isEnabled && !selectedWidget) {
        return _theLoops.THELOOPS_MESSAGES.WIDGET_ENABLE_ERROR;
      }

      return null;
    }
  }, {
    key: "getErrorMessage",
    value: function getErrorMessage(error, fallback, prefix) {
      var _error$response2, _error$response2$data;

      if (error !== null && error !== void 0 && (_error$response2 = error.response) !== null && _error$response2 !== void 0 && (_error$response2$data = _error$response2.data) !== null && _error$response2$data !== void 0 && _error$response2$data.message) return "".concat(prefix, ": ").concat(error.response.data.message);
      if (error !== null && error !== void 0 && error.message) return "".concat(prefix, ": ").concat(error.message);
      return fallback;
    }
  }]);
  return TheLoopsIntegration;
}(_preact.Component);

var _default = TheLoopsIntegration;
exports.default = _default;